import { createContext, PropsWithChildren, useMemo } from 'react'
import { useTopBanner } from './TopBanner/useTopBanner'

export interface LayoutContextValueProps {
  showTopBanner: boolean
  dismissTopBanner: () => void
}

export const LayoutContext = createContext<LayoutContextValueProps | null>(null)

export const LayoutProvider = (props: PropsWithChildren) => {
  const { children } = props
  const { show: showTopBanner, dismiss: dismissTopBanner } = useTopBanner()

  const values = useMemo(
    () => ({
      showTopBanner,
      dismissTopBanner,
    }),
    [showTopBanner, dismissTopBanner]
  )

  return (
    <LayoutContext.Provider value={values}>{children}</LayoutContext.Provider>
  )
}
